export const getZeroPadTransform = (digits: number) => (value: number | string) => {
  if (value === '') {
    return value;
  }

  return String(value).padStart(digits, '0');
};

export const twoDigitZeroPadTransform = getZeroPadTransform(2);
export const fourDigitZeroPadTransform = getZeroPadTransform(4);

export const fourDigitFuturePadTransform = (value: number | string) => {
  if (value === '') return value;

  const strValue = String(Number(value)); // This removes leading zeros

  if (strValue.length === 1) {
    return `200${strValue}`;
  } else if (strValue.length === 2) {
    return `20${strValue}`;
  } else if (strValue.length === 3) {
    return `2${strValue}`;
  } else {
    return strValue;
  }
};

export const fourDigitPastPadTransform = (value: number | string) => {
  if (value === '') return value;

  const fullCurrentYear: number = new Date().getFullYear();

  const numValue = Number(value); // This removes leading zeros
  const strValue = String(numValue);

  // Get last 2 digits of the current year
  const currentYearLast2Digits = fullCurrentYear % 100;

  if (strValue.length === 2) {
    if (numValue <= currentYearLast2Digits) {
      return `20${strValue}`;
    } else {
      return `19${strValue}`;
    }
  } else if (strValue.length === 1) {
    return `200${strValue}`;
  } else if (strValue.length === 3) {
    return `1${strValue}`;
  } else {
    return strValue;
  }
};

export const fourDigitPadTransform = (name: string, value: number | string) => {
  if (name === 'customerDateOfBirth' || name === 'dateOfBirth') {
    return fourDigitPastPadTransform(value);
  } else {
    return fourDigitFuturePadTransform(value);
  }
};
